module.exports = __webpack_public_path__ + "static/media/ceo-icon.dd72773e.png";